import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { authClient } from '../auth/client.js';

export function MfaSetup() {
  const nav = useNavigate();
  const [step, setStep] = useState<'password' | 'enroll' | 'done'>('password');
  const [password, setPassword] = useState('');
  const [totpUri, setTotpUri] = useState<string | null>(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);

  const enable = async () => {
    setError(null);
    try {
      const res = (await authClient.twoFactor.enable({ password })) as {
        data?: { totpURI?: string };
      };
      setTotpUri(res.data?.totpURI ?? null);
      setStep('enroll');
    } catch (e: unknown) {
      setError((e as Error).message);
    }
  };

  const verify = async () => {
    setError(null);
    try {
      await authClient.twoFactor.verifyTotp({ code });
      nav('/app');
    } catch (e: unknown) {
      setError((e as Error).message);
    }
  };

  return (
    <div className="mx-auto mt-16 max-w-md rounded border bg-white p-6">
      <h1 className="mb-4 text-xl font-semibold">Activar 2FA</h1>
      {step === 'password' && (
        <div className="space-y-3">
          <input
            type="password"
            placeholder="Contraseña actual"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded border px-3 py-2"
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button
            type="button"
            onClick={() => void enable()}
            className="w-full rounded bg-blue-600 py-2 text-white"
          >
            Continuar
          </button>
        </div>
      )}
      {step === 'enroll' && totpUri && (
        <div className="space-y-3">
          <p className="text-sm text-slate-600">
            Escanea este código con tu app de autenticación (Authy, Google Authenticator,
            1Password):
          </p>
          <div className="flex justify-center rounded bg-white p-4">
            <QRCodeSVG value={totpUri} size={208} level="M" includeMargin={false} />
          </div>
          <details className="text-xs">
            <summary className="cursor-pointer text-slate-500 hover:text-slate-700">
              ¿No puedes escanear? Copia el secreto manualmente
            </summary>
            <code className="mt-2 block break-all rounded bg-slate-100 p-2 text-[10px]">
              {totpUri}
            </code>
          </details>
          <input
            type="text"
            placeholder="Código de 6 dígitos"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            inputMode="numeric"
            pattern="[0-9]{6}"
            maxLength={6}
            className="w-full rounded border px-3 py-2 text-center text-lg tracking-widest"
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button
            type="button"
            onClick={() => void verify()}
            className="w-full rounded bg-blue-600 py-2 text-white"
          >
            Verificar y activar
          </button>
        </div>
      )}
    </div>
  );
}
